const $ = jQuery.noConflict();

'use strict';

const Tabs = {
	/**
	 * @description Cache DOM elements
	 */
	$tabButtons: $('.js-tab-btn'),
	$tabContents: $('.js-tab-content'),
	classActive: 'is-active',

	/**
	 * @description Initialize the Tabs functionality
	 */
	init: function() {
		this.bindEvents();
		this.showActiveTab(); // Display the initially active tab
	},

	/**
	 * @description Bind click events to tabs and "View All" buttons
	 */
	bindEvents: function() {
		this.$tabButtons.on('click', this.handleTabClick.bind(this));
		$('.ja-tab-init').on('click', this.handleViewAllClick.bind(this));
	},

	/**
	 * @description Handle tab button clicks
	 */
	handleTabClick: function(e) {
		const $currentButton = $(e.target);
		const targetTab = $currentButton.data('tab');

		// Update active states on buttons
		this.$tabButtons.removeClass(this.classActive);
		$currentButton.addClass(this.classActive);

		// Display the corresponding tab content
		this.$tabContents.hide();
		this.$tabContents.filter(`[data-tab="${targetTab}"]`).fadeIn();
	},

	/**
	 * @description Handle "View All" button clicks
	 */
	handleViewAllClick: function(e) {
		const $currentButton = $(e.target).closest('.ja-tab-init');
		const targetTab = $currentButton.data('tab');

		// Trigger the corresponding tab button
		this.$tabButtons.filter(`[data-tab="${targetTab}"]`).trigger('click');

		$('html, body').animate({
			scrollTop: 0,
		}, 500);
	},

	/**
	 * @description Display the initial active tab
	 */
	showActiveTab: function() {
		const activeTab = this.$tabButtons.filter(`.${this.classActive}`).data('tab');
		this.$tabContents.hide();
		this.$tabContents.filter(`[data-tab="${activeTab}"]`).fadeIn();
	},
};

export default Tabs;
